import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/bmi-maker',
      name: 'bmi-maker',
      component: () => import( './views/BMIMaker.vue')
    },
    {
      path: '/twitter-share',
      name: 'twitter-share',
      component: () => import( './views/parts/TwitterShare.vue')
    },
    {
      path: '/button-parts-count-up',
      name: 'button-parts-count-up',
      component: () => import( './views/parts/ButtonPartsCountUp.vue')
    },
    {
      path: '/class-binding',
      name: 'class-binding',
      component: () => import( './views/parts/ClassBinding.vue')
    },
    {
      path: '/head-meta-change',
      name: 'head-meta-change',
      component: () => import( './views/parts/HeadMeta.vue')
    },
    {
      path: '/computed-data',
      name: 'computed-data',
      component: () => import( './views/parts/ComputedData.vue')
    },
    {
      path: '/input-database',
      name: 'input-database',
      component: () => import( './views/parts/InputDatabase.vue')
    },
    {
      path: '/janken',
      name: 'janken',
      component: () => import( './views/apps/Janken.vue')
    },
    {
      path: '/for',
      name: 'for',
      component: () => import( './views/parts/For.vue')
    },
    {
      path: '/router-watch/:id',
      name: 'router-watch',
      component: () => import( './views/parts/RouterWatch.vue')
    },
    {
      path: '/v-model',
      name: 'v-model',
      component: () => import( './views/parts/Vmodel.vue')
    },
    {
      path: '/shopping',
      name: 'shopping',
      component: () => import( './views/apps/Shopping.vue')
    },
    {
      path: '/v-if',
      name: 'v-if',
      component: () => import( './views/parts/Vif.vue')
    },
    {
      path: '/window-size',
      name: 'window-size',
      component: () => import( './views/parts/WindowSize.vue')
    },
    {
      path: '/omikuji',
      name: 'omikuji',
      component: () => import( './views/apps/Omikuji.vue')
    },
    {
      path: '/sort',
      name: 'sort',
      component: () => import( './views/parts/Sort.vue')
    },
    {
      path: '/transition',
      name: 'transition',
      component: () => import( './views/parts/Transition.vue')
    },
    {
      path: '/mojisu',
      name: 'mojisu',
      component: () => import( './views/apps/Mojisu.vue')
    },
    {
      path: '/chat',
      name: 'chat',
      component: () => import( './views/apps/Chat.vue')
    },
  ]
})

